import React, { useState, useEffect, useRef } from "react";
import ParagraphTag from "../../reusebale/Paragraph";
import HeadingTag from "../../reusebale/heading";
import db from "../../../db/index.json";
import { Menu, X } from "lucide-react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // Import useNavigate

const HeaderSection = ({ onNotificationClick, onChangePasswordClick }) => {
  const { loginSuccess } = useSelector((state) => state.auth);
  const { rightPanel } = db;
  const navigate = useNavigate();

  // State to toggle dropdown
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Function to toggle menu
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="w-full pt-4">
      <div className="flex justify-between items-center">
        {/* Welcome Message */}
        <div>
          <ParagraphTag
            content={`Hi, ${loginSuccess?.user?.firstName} ${loginSuccess?.user?.lastName}`}
            classes="text-black/40 font-popinsMedium text-xs"
          />
          <HeadingTag
            title={rightPanel.welcomeMsg}
            classes="font-popinsSemiBold text-black text-xl mt-[-4px]"
          />
        </div>

        {/* Burger Menu */}
        <div ref={dropdownRef} className="relative">
          <div
            className="w-10 h-10 bg-white rounded-full flex justify-center items-center cursor-pointer shadow-md"
            onClick={toggleMenu}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </div>

          {/* Dropdown Menu */}
          {isOpen && (
            <div className="absolute z-20 right-0 mt-2 w-48 bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300">
              <ul className="py-2">
                {/* <li className="px-4 py-2 hover:bg-gray-200 cursor-pointer" onClick={onNotificationClick}>Notification</li> */}
                <li className="px-4 py-2 hover:bg-gray-200 cursor-pointer" onClick={() => navigate("/reset-password")}>Change Password</li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
